import { useTranslation } from "react-i18next";
import { ResortSearchForm } from "./ResortSearchForm";

export const ResortHero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[70vh] overflow-hidden" aria-label="Banner de Resorts">
      {/* Background Image - Using img with srcset for better mobile performance */}
      <img 
        src="https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=800&q=60"
        srcSet="https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=640&q=60 640w, https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=800&q=60 800w, https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1280&q=50 1280w, https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1920&q=40 1920w"
        sizes="100vw"
        alt=""
        role="presentation"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground/60 via-foreground/40 to-foreground/70" />
      
      <div className="container relative mx-auto flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary-foreground/20 bg-primary-foreground/10 px-4 py-2 backdrop-blur-sm">
          <span className="text-sm font-medium text-primary-foreground">{t('resorts.badge')}</span>
        </div>
        
        {/* Main Title */}
        <h1 className="mb-4 font-serif text-4xl font-bold leading-tight text-primary-foreground md:text-5xl lg:text-6xl">
          {t('resorts.heroTitle')}
        </h1>
        
        {/* Description */}
        <p className="mb-10 max-w-2xl text-lg text-primary-foreground/80">
          {t('resorts.heroSubtitle')}
        </p>

        {/* Search Form */}
        <div className="w-full max-w-4xl">
          <ResortSearchForm />
        </div>
      </div>

      {/* Decorative Element - Bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          preserveAspectRatio="none"
        >
          <path
            d="M0 60L1440 60L1440 30C1200 50 960 10 720 30C480 50 240 10 0 30L0 60Z"
            fill="hsl(var(--background))"
          />
        </svg>
      </div>
    </section>
  );
};
